import { Stack, StackProps, styled } from "@mui/material";

export const DialogFeet: React.FC<StackProps> = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  maxWidth: theme.breakpoints.values.sm,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(2),
  },
}));
